import React from "react";
import LoginWithOtpSevice from "./LoginWithOtpSevice";
import { NavLink } from "react-router-dom";

const LoginWithOtp = () => {
  const {
    handleChangeOTP,
    inputOtp,
    generateOtp,
    validationOTPErrors,
    logInWithOtp,
    isOtpGenerated,
    otpValue,
    setOtpValue,
  } = LoginWithOtpSevice();
  return (
    <>
      <div className="cus-wrapper">
        <div className="wrapper cus-otp-wrapper">
          <div className="title-text">
            {/* <div className="title login cus-login-1">
              <img
                src="assets/pwa-static/pwa/images/zupay-logo.png"
                alt="logo"
              />
            </div> */}
          </div>

          <div className="login-otp">
            <h1>Login</h1>
          </div>
          <div className="form-container cus-otp-mt">
            <form className="signup">
              <div className="field">
                <input
                  className="cus-otp-input-area"
                  type="text"
                  placeholder="Mobile Number"
                  name="UserID"
                  onChange={handleChangeOTP}
                  value={inputOtp?.UserID}
                />
                {validationOTPErrors.UserID && (
                  <span className="text-danger-inputfield">
                    {validationOTPErrors.UserID}
                  </span>
                )}
              </div>

              {isOtpGenerated && (
                <div className="field">
                  <input
                    className="cus-otp-input-area"
                    type="text"
                    placeholder="Enter OTP"
                    value={otpValue}
                    onChange={(e) => setOtpValue(e.target.value)}
                  />
                </div>
              )}

              <div className="field btn cus-field-otp-area">
                <div className="btn-layer"></div>
                {!isOtpGenerated ? (
                  <button type="button" onClick={generateOtp}>
                    Get OTP
                  </button>
                ) : (
                  <button type="button" onClick={logInWithOtp}>
                    Login with OTP
                  </button>
                )}
              </div>

              <div className="cus-register-section cus-otp-resgistration">
                <div className="pass-link">
                  <NavLink to="/signup">Register Now</NavLink>
                </div>
                <div className="pass-link">
                  <NavLink to="/forgetpassword">Forgot password?</NavLink>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginWithOtp;
